import { FETCH_USER_FAILURE, FETCH_USER_PROFILE_REQUEST, FETCH_USER_SUCCESS } from "../../actions";
const initialState = {
    data: null,
    isOnboarding: false,
    loading: false,
    error: null,
};
const userReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_USER_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload, isOnboarding: action.isOnboarding });
        case FETCH_USER_PROFILE_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, data: action.payload, error: null });
        case FETCH_USER_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        default:
            return state;
    }
};
export default userReducer;
